// Chakra imports
import {
  Box,
  Flex,
  Grid,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdInfo } from "react-icons/md";
import Card from "components/card/Card";
// Custom components
import { useHistory } from "react-router-dom";
import { AuthContext } from "contexts/requiredAuth";
import PopOverAlertOrange from "components/popAlert/popAlert";
import React, { useState, useEffect, useContext } from "react";
import { buscarLojasNaAPI } from "config/apis/requests";
import routes from "routes";
import IconBox from "components/icons/IconBox";
import { checkProfiles } from "config/functions";

export default function Default() {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "secondaryGray.600";
  const [isOpenErro, setIsOpenErro] = useState(false);
  const { logout, user } = useContext(AuthContext);
  const handleOpenAlertErro = () => {
    setIsOpenErro(!isOpenErro);
  };
  const { push } = useHistory();
  const handleLogout = () => {
    logout();
    push("/auth/sign-in");
  };

  useEffect(() => {
    const fetchLojas = async () => {
      try {
        const res = await buscarLojasNaAPI();
        if (typeof res !== "undefined" && Array.isArray(res)) {
          if (localStorage.getItem("lojas")) {
            localStorage.removeItem("lojas");
          }
          localStorage.setItem("lojas", JSON.stringify(res));
        } else if (res === 403) {
          handleLogout();
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchLojas();
  }, []);

  // Função para achatar as rotas e encontrar os serviços disponíveis
  const getAvailableServices = (routes: any[]) => {
    const services: any[] = [];
    const perfis = user?.perfis || [];

    const findServices = (items: any[], parentName: string = "") => {
      items.forEach((route) => {
        const allowed = checkProfiles(route.allowedProfiles, perfis);
        if (allowed) {
          if (route.collapse && route.items) {
            findServices(route.items, route.name);
          } else if (route.layout === "/admin") {
            // Evita duplicatas baseadas no nome e path
            if (!services.find((s) => s.name === route.name && s.path === route.path)) {
              services.push({
                ...route,
                parentName: parentName,
              });
            }
          }
        }
      });
    };

    findServices(routes);
    return services;
  };

  const availableServices = getAvailableServices(routes);

  // Filtra apenas os serviços que queremos mostrar como cards principais (baseado na imagem)
  const mainServices = availableServices.filter((service) => {
    const name = service.name.toLowerCase();
    const parentName = service.parentName ? service.parentName.toLowerCase() : "";
    
    // Lista de nomes permitidos para os cards principais
    const allowedNames = [
      "cliente",
      "consulta avulso",
      "sênior",
      "pcd / dc",
      "estudante",
      "pendente aprovação",
      "atendimento"
    ];

    return allowedNames.some(allowed => name.includes(allowed) || parentName.includes(allowed));
  });

  // Mapeamento de nomes, sub-nomes e cores para os cards
  const getCardInfo = (service: any) => {
    const name = service.name;
    const parent = service.parentName;

    if (name === "Cliente" && parent === "Atendimento")
      return {
        title: "Atendimento",
        sub: "Cliente",
        iconColor: "blue.500",
        bgColor: "blue.50",
      };
    if (name === "Consulta Avulso")
      return {
        title: "Consulta",
        sub: "Avulso",
        iconColor: "cyan.500",
        bgColor: "cyan.50",
      };
    if (name === "Atendimento" && parent === "Sênior")
      return {
        title: "Sênior",
        sub: "Gratuidades",
        iconColor: "orange.500",
        bgColor: "orange.50",
      };
    if (name === "Pendente aprovação" && parent === "Sênior")
      return {
        title: "Consulta Aprovação",
        sub: "Pendente",
        iconColor: "green.500",
        bgColor: "green.50",
      };
    if (name === "Atendimento" && parent === "PCD / DC")
      return {
        title: "PCD / DC",
        sub: "Gratuidades",
        iconColor: "purple.500",
        bgColor: "purple.50",
      };
    if (name === "Atendimento" && parent === "Estudante")
      return {
        title: "Estudante",
        sub: "Passe Escolar",
        iconColor: "teal.500",
        bgColor: "teal.50",
      };

    return {
      title: name,
      sub: parent || "Geral",
      iconColor: "brand.500",
      bgColor: "secondaryGray.300",
    };
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <PopOverAlertOrange
        handleOpenAlert={handleOpenAlertErro}
        isOpen={isOpenErro}
        title="Ops..."
        subtitle={""}
      />
      
      <Flex direction="column" mb="25px">
        {/*<Card*/}
        {/*  p="20px"*/}
        {/*  h="max-content"*/}
        {/*  bgColor={"blackAlpha.50"}*/}
        {/*  mb="25px"*/}
        {/*>*/}
        {/*  <Flex align="center" mb="10px">*/}
        {/*    <IconBox*/}
        {/*      h="30px"*/}
        {/*      w="30px"*/}
        {/*      bg="brand.500"*/}
        {/*      icon={<Icon as={MdInfo} color="white" h="18px" w="18px" />}*/}
        {/*      me="10px"*/}
        {/*    />*/}
        {/*    <Text*/}
        {/*      color={"blue.200"}*/}
        {/*      fontSize="20px"*/}
        {/*      fontWeight="700"*/}
        {/*    >*/}
        {/*      Novas Features*/}
        {/*    </Text>*/}
        {/*  </Flex>*/}
        {/*  <Text*/}
        {/*    color={textColor}*/}
        {/*    fontSize="14px"*/}
        {/*    fontWeight="500"*/}
        {/*    mt="10px"*/}
        {/*  >*/}
        {/*    Selecione o menu ATENDIMENTO - CLIENTE para utilizar esta nova funcionalidade.*/}
        {/*  </Text>*/}
        {/*</Card>*/}

        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          mb="20px"
          mt="20px"
        >
          Serviços Disponíveis
        </Text>

        <Grid
          templateColumns={{
            base: "1fr",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
            xl: "repeat(6, 1fr)",
          }}
          gap="20px"
          mb="25px"
        >
          {mainServices.map((service, index) => {
            const info = getCardInfo(service);
            return (
              <Card
                key={index}
                p="20px"
                cursor="pointer"
                transition="0.2s linear"
                _hover={{ transform: "translateY(-5px)", boxShadow: "lg" }}
                onClick={() => push(service.layout + service.path)}
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <IconBox
                  h="64px"
                  w="64px"
                  bg={useColorModeValue(info.bgColor, "navy.700")}
                  icon={React.cloneElement(service.icon as React.ReactElement, {
                    h: "32px",
                    w: "32px",
                    color: useColorModeValue(info.iconColor, "white"),
                  })}
                  mb="15px"
                />
                <Text color={textColor} fontSize="md" fontWeight="700">
                  {info.title}
                </Text>
                <Text color={textColorSecondary} fontSize="sm" fontWeight="500">
                  {info.sub}
                </Text>
              </Card>
            );
          })}
        </Grid>

      </Flex>
    </Box>
  );
}
